import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {
  FetchDashboardFilterModel
} from "../../clients-list/model/fetch-dashboard-filter.model";
import {
  FetchGroupsListModel
} from "../../clients-list/model/fetch-groups-list.model";
import {v1URL} from "../../../shared/constants/urls.constants";
import {CommonService} from "../../../shared/services/common.service";
import {
  FetchClinicFilterModel
} from "../../clients-list/model/fetch-clinic-filter.model";
import {
  FetchStatusFilterModel
} from "../../clients-list/model/fetch-status-filter.model";
import {
  FetchGroupTypeFilterModel
} from "../../clients-list/model/fetch-group-type-filter.model";
import {
  FetchParticipantsAndCaregiversListModel
} from '../../clients-list/model/fetch-participants-and-caregivers-list.model';
import {
  FetchGroupFilterModel
} from '../../clients-list/model/fetch-group-filter.model';
import {
  FetchUserStatusFilterModel
} from '../../clients-list/model/fetch-user-status-filter.model';
import {
  FetchParticipantsWeightListModel
} from '../../clients-list/model/fetch-participants-weight-list.model';
import {
  FetchParticipantsBehaviourListModel
} from "../../clients-list/model/fetch-participants-behaviour-list.model";

@Injectable({
  providedIn: 'root',
})
export class AdminGroupsListService {
  constructor(
    private commonServices: CommonService
  ) {
  }

  fetchDashboardFilter(): Observable<FetchDashboardFilterModel['response']> {
    return of({
      success: true,
      code: 'Dummy Code ABCD1234',
      message: 'Dummy Message',
      data: {
        list: [
          {

            key: 1,
            value: 'Group Information'
          },
          {
            key: 2,
            value: 'Participant/Adult Information'
          },
          {
            key: 3,
            value: 'Participant Weight'
          },
          {
            key: 4,
            value: 'Participant Behavior'
          }
        ],
        total: null,
        pageNumber: 1,
        limit: 10,
        hasNext: false,
        hasPrev: false,
        loading: false
      }
    })
  }

  fetchGroupsList(payload: FetchGroupsListModel['request']): Observable<FetchGroupsListModel['response']> {
    const urlConfig = v1URL.groups.fetchAll
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchClinicFilter(): Observable<FetchClinicFilterModel['response']> {
    return of({
      success: true,
      code: 'Dummy Code ABCD1234',
      message: 'Dummy Message',
      data: {
        list: [
          {
            key: 9,
            value: 'Clinic 1'
          },
          {

            key: 49,
            value: 'Clinic 2'
          },
          {
            key: 52,
            value: 'Clinic 3'
          },
          {
            key: 4,
            value: 'Clinic 4'
          },
          {
            key: -2,
            value: 'Select All'
          }
        ],
        total: null,
        pageNumber: 1,
        limit: 10,
        hasNext: false,
        hasPrev: false,
        loading: false
      }
    })
  }

  fetchStatusFilter(): Observable<FetchStatusFilterModel['response']> {
    const urlConfig = v1URL.filters.groupStatus
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchGroupTypeFilter(): Observable<FetchGroupTypeFilterModel['response']> {
    const urlConfig = v1URL.filters.groupType
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchParticipantsAndCaregiversList(payload: FetchParticipantsAndCaregiversListModel['request']): Observable<FetchParticipantsAndCaregiversListModel['response']> {
    const urlConfig = v1URL.dashboard.participantCaregiver
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchGroupListFilter(payload: FetchGroupFilterModel['request']): Observable<FetchGroupFilterModel['response']> {
    const urlConfig = v1URL.filters.groups
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchUserStatusListFilter(): Observable<FetchUserStatusFilterModel['response']> {
    const urlConfig = v1URL.filters['user-status']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchParticipantsWeightList(payload: FetchParticipantsWeightListModel['request']): Observable<FetchParticipantsWeightListModel['response']> {
    const urlConfig = v1URL.dashboard.participantWeightInformation
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchParticipantsBehaviourList(payload: FetchParticipantsBehaviourListModel['request']): Observable<FetchParticipantsBehaviourListModel['response']> {
    const urlConfig = v1URL.dashboard.participantBehaviourInformation
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }
}
